import Skeleton from 'react-loading-skeleton';

function SkeletonWrap({ isLoading, skeleton, content }: { isLoading: boolean; skeleton?: any; content: any }) {
  if (isLoading) {
    return skeleton || <Skeleton />;
  }

  return content || null;
}

export function SkeletonDiscover() {
  return (
    <div className="pt-6 w-full">
      <Skeleton height={80} />
      <Skeleton height={60} className="mt-6" />
      <div className="flex flex-row items-center flex-wrap">
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
      </div>
      <Skeleton height={60} className="mt-6" />
      <div className="flex flex-row items-center flex-wrap">
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
        <Skeleton height={100} width={300} className="mt-4 mr-4" />
      </div>
    </div>
  );
}

export default SkeletonWrap;
